var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "cashback",
    width: 45.4,
    height: 45.4,
    viewBox: "0 0 45.4 45.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M4.611,320.621H1.33A1.33,1.33,0,0,1,0,319.291V303.33A1.33,1.33,0,0,1,1.33,302H4.611a1.33,1.33,0,0,1,1.33,1.33v15.961A1.33,1.33,0,0,1,4.611,320.621Z",
    transform: "translate(0 -275.221)",
    fill: "#4e3057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M132.136,315.264a3.21,3.21,0,0,0-3.266.1L124,318.446a5.768,5.768,0,0,1-5.723,5.081h-6.613a1.355,1.355,0,0,1-1.366-1.266,1.33,1.33,0,0,1,1.329-1.394h6.65a3.107,3.107,0,0,0,3.1-3.178,3.141,3.141,0,0,0-3.161-3.029h-7.479l-.868-.651a10.048,10.048,0,0,0-11.2-.578L97,314.439v13.522h22.356A6.651,6.651,0,0,0,123,326.877l9.349-6.113a3.21,3.21,0,0,0-.209-5.5Z",
    transform: "translate(-88.399 -284.335)",
    fill: "#4e3057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M98.084,0a11.084,11.084,0,1,0,11.084,11.084A11.1,11.1,0,0,0,98.084,0Zm1.33,16.588v.26a1.33,1.33,0,1,1-2.66,0v-.261a3.556,3.556,0,0,1-2.146-2.578,1.33,1.33,0,0,1,2.607-.529.887.887,0,1,0,.869-1.065,3.546,3.546,0,0,1-1.33-6.834V5.32a1.33,1.33,0,1,1,2.66,0v.261a3.556,3.556,0,0,1,2.145,2.578,1.33,1.33,0,1,1-2.607.529.887.887,0,1,0-.869,1.065,3.546,3.546,0,0,1,1.33,6.834Z",
    transform: "translate(-79.286)",
    fill: "#4e3057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M342.171,36a1.33,1.33,0,0,0-1.2-.766h-1.936a22.692,22.692,0,0,0-13.246-15.367A13.729,13.729,0,0,1,329.06,32.4a14.8,14.8,0,0,1,1.55,2.833H329.44a1.33,1.33,0,0,0-1.022,2.182l5.764,6.916a1.33,1.33,0,0,0,2.044,0l5.764-6.916A1.33,1.33,0,0,0,342.171,36Z",
    transform: "translate(-296.897 -18.107)",
    fill: "#4e3057"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashback);
export default __webpack_public_path__ + "static/media/cashback.5e705eb9de30e0df37a0a7598ac9ebdf.svg";
export { ForwardRef as ReactComponent };